<nav class="navbar navbar-expand-lg navbar-light bg-light rounded">
  <a class="navbar-brand" href="#">NgxSample</a>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbar"
    aria-controls="navbar"
    aria-expanded="false"
    aria-label="ナビゲーションの切替"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbar">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <a class="nav-link" routerLink="/top" routerLinkActive="active">Top</a>
      </li>
      <li *ngIf="isDev" class="nav-item">
        <a class="nav-link" routerLink="/wip">WIP</a>
      </li>
    </ul>
    <!--<form class="form-inline my-2 my-md-0">-->
    <!--<input class="form-control" type="search" placeholder="検索..." aria-label="検索...">-->
    <!--</form>-->
  </div>
</nav>
<router-outlet></router-outlet>
